import PlatformModerationHeaderContainer from './PlatformModerationHeader.container'

export default PlatformModerationHeaderContainer